import { merge } from "lodash-es";
import { PropsWithChildren } from "react";
import { SimpleForm as RaSimpleForm, SimpleFormProps } from "react-admin";

import { FormToolbar } from "../FormToolbar";

export const SimpleForm = ({ children, ...props }: PropsWithChildren<Partial<SimpleFormProps>>) => {
  return (
    <RaSimpleForm
      sx={merge(
        {
          ...{
            padding: "20px",
            "> *": {
              gap: "10px"
            }
          }
        },
        props.sx
      )}
      mode="onChange"
      reValidateMode="onChange"
      toolbar={<FormToolbar />}
      {...props}
    >
      {children}
    </RaSimpleForm>
  );
};
